import type { FieldErrors } from "react-hook-form";

import { toast } from "components/ui/use-toast";

export function firstErrorMessage(errors: FieldErrors): string | null {
  for (const value of Object.values(errors ?? {})) {
    if (!value) continue;

    const message = (value as { message?: unknown }).message;
    if (typeof message === "string" && message) return message;

    if (typeof value === "object") {
      const nested = firstErrorMessage(value as FieldErrors);
      if (nested) return nested;
    }
  }
  return null;
}

export const SUBMIT_BLOCKED_FALLBACK =
  "Há campos inválidos no formulário. Revise os passos anteriores.";

export const STEP_BLOCKED_FALLBACK =
  "Há campos inválidos neste passo. Revise antes de continuar.";

export function warnStepBlocked(reason: string | null): void {
  toast({
    description: `Não foi possível continuar: ${reason ?? STEP_BLOCKED_FALLBACK}`,
    variant: "destructive",
  });
}
